import { Divider, Flex, theme, Typography } from 'antd';
import { memo, type ReactNode } from 'react';
import { type EditableSiteMenuOrder } from './customer-order-form.utils';
import AuthorizedComponent from '../../../../components/authorized-component';
import { Roles } from '../../../../types';
import { totalMeals, totalPrice } from '../../../../utils/order-utils';
import utils from '../../../../utils/utils';

/** The totals of the order being placed */
const CustomerOrderTotals = ({
  siteMenuOrders,
}: {
  siteMenuOrders: EditableSiteMenuOrder[];
}): ReactNode => {
  const { token } = theme.useToken();
  return (
    <Flex gap={token.marginXXS} wrap="wrap">
      <Flex justify="space-between" flex="0 0 100%">
        <Divider />
      </Flex>
      <Flex justify="space-between" flex="0 0 100%">
        <Typography.Title level={3} style={{ marginBlockStart: 0, marginBlockEnd: token.marginSM }}>
          Order summary
        </Typography.Title>
      </Flex>
      <Flex justify="space-between" flex="0 0 100%">
        <Typography.Text>Total number of meals</Typography.Text>
        <Typography.Text>{utils.numberFormat(totalMeals(siteMenuOrders))}</Typography.Text>
      </Flex>
      <AuthorizedComponent roles={[Roles.ROLE_HHC_ADMIN, Roles.ROLE_CUSTOMER_ADMIN]}>
        <Flex justify="space-between" flex="0 0 100%">
          <Typography.Text strong style={{ fontSize: token.fontSizeHeading4 }}>
            Total Price
          </Typography.Text>
          <Typography.Text strong style={{ fontSize: token.fontSizeHeading5 }}>
            {utils.currencyFormat(totalPrice(siteMenuOrders))}
          </Typography.Text>
        </Flex>
      </AuthorizedComponent>
    </Flex>
  );
};

export default memo(CustomerOrderTotals);
